import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { TokenService } from 'src/app/services/token.service';
import { ValidationMessages } from '../input-primecap/model/validator.model';
import { ModalPushComponent } from './modal-push/modal-push.component';
import { Rodada } from '../../model/rodada';
import { PushConfirme, PushProgress } from './model/push';
import { take } from 'rxjs/operators';
import { DadosModal } from '../../model/dados-modal';
import { PushCoreService } from '../../core/push-core.service';

@Component({
  selector: 'progress-page',
  templateUrl: './progress-page.component.html',
  styleUrls: ['./progress-page.component.css']
})
export class ProgressPageComponent implements OnInit, AfterContentChecked {
  logo: string;
  startup: string;
  tecnologia: string;
  uuidRodada: string;
  investidor: string;
  uuidInvestidor: string;
  startups: any[] = [];
  investidores: any[] = [];
  @ViewChild('stepper') stepper: MatStepper;
  valor: string;
  formInput!: UntypedFormGroup;
  errorCustom: ValidationMessages = {};
  validationMessages!: ValidationMessages;
  pushConfirme = new PushConfirme();
  constructor(
    private cdr: ChangeDetectorRef,
    public pushCoreSevice: PushCoreService,
    private tokenUsuario: TokenService,
    public dialog: MatDialog
    ) {}
  ngOnInit(): void {
    this.pushCoreSevice.getRodadasPush().pipe(take(1)).subscribe((res)=> {
      res.dados[0].content.forEach((rodada: Rodada) => {
        let push: PushProgress = {};
        push.uuid = rodada.uuid
        push.principal = rodada.empresaNome;
        push.logo = rodada.empresaLogo;
        this.startups.push(push)
      })
    })
    const uuidAssessor = this.tokenUsuario.carregarUsuarioLogado().uuidTipoUsuario
    this.pushCoreSevice.getInvestidoresPush(uuidAssessor).subscribe((res)=>{
      let push : PushProgress = {};
      res.dados[0].content.forEach(investidor =>{
        push.principal = investidor.nome.toLocaleUpperCase()
        push.uuid = investidor.uuid
        this.investidores.push(push)
        push = {}
      })
    })
  }

  next(index: number) {
    this.stepper.selectedIndex = index;
  }

  recebeItem(item : PushProgress){
    this.uuidRodada = item.uuid
    this.logo = item.logo;
    this.startup = item.principal;
    this.tecnologia = item.auxiliar;
  }

  ngAfterContentChecked(): void {
  	this.cdr.detectChanges();
  }

  recebeInvestidor(item : PushProgress){
    this.uuidInvestidor = item.uuid
    this.investidor = item.principal.toUpperCase()
  }

  exibirModalPush(){
    this.pushConfirme.uuidRodada = this.uuidRodada;
    this.pushConfirme.uuid = this.uuidInvestidor;
    this.pushConfirme.nomeInvestidor = this.investidor;
    this.pushConfirme.startup = this.startup;
    this.pushConfirme.valorInvestimento = Number(this.valor);

    let dados = new DadosModal<PushConfirme>({
      tituloModal: 'Confime o investidor',
      tamanhoModal: 'medium',
      objeto: this.pushConfirme
    });

    this.dialog.open(ModalPushComponent, {
			data: dados,
		});
  }
}
